import {
    COLUMN_NAME,
    COLUMN_TYPE
} from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";
import { FILTER_REPORT_TYPE } from "../../constants/filter-types";

const KsKeysColumns: TableColumn[] = [
    {
        id: 0,
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        sortByName: "name",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        id: 1,
        heading: "Type",
        accessor: "ksKeyTypeName",
        isNumeric: false,
        active: true,
        translationKey: "type",
        filterId: FILTER_REPORT_TYPE,
        columnId: COLUMN_TYPE,
        searchOnName: "ksKeyType.id",
        sortByName: "ksKeyType.trnName",
        lookupName: "ksKeyType.trnName",
        sortDirection: "asc",
        // settingDataName: 'ksKeyType',
    },
];

export default KsKeysColumns;
